import TagTooltipContainer from './TagTooltipContainer.styled';

export default TagTooltipContainer;
